import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatatableComponent } from './datatable/datatable.component';
import { MapComponent } from './map/map.component';
import { PlateNumberComponent } from './plate-number/plate-number.component';
import { StatusComponent } from './status/status.component';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { ServiceIconsComponent } from './service-icons/service-icons.component';
import { StepperComponent } from './stepper/stepper.component';
import { BillingSummaryComponent } from './billing-summary/billing-summary.component';
import { HttpClientModule } from '@angular/common/http';
import { HomeService } from '../pages/home/services/home.service';
import { LogoutComponent } from './logout/logout.component';
import { ToggleComponent } from './toggle/toggle/toggle.component';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerDatatableComponent } from './spinner-datatable/spinner-datatable.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { GanttComponent } from './gantt/gantt.component';
import { CancelModalComponent } from './datatable/components/cancel-modal/cancel-modal.component';
import { VehicleStatusComponent } from './vehicle-status/vehicle-status.component';
import { AlertComponent } from './alert/alert.component';
import { AddressBoxComponent } from './billing-summary/components/address-box/address-box.component';
import { AdditionalInfoComponent } from './billing-summary/components/additional-info/additional-info.component';
import { CommentsComponent } from './billing-summary/components/comments/comments.component';
import { PricingSummaryComponent } from './billing-summary/components/pricing-summary/pricing-summary.component';
import { CancellationPolicyComponent } from './billing-summary/components/cancellation-policy/cancellation-policy.component';
import { CheckoutContainerComponent } from './billing-summary/components/checkout-container/checkout-container.component';
import { ModalPromotionCodeComponent } from './billing-summary/modals/modal-promotion-code/modal-promotion-code.component';
import { ModalCancellationPolicyComponent } from './billing-summary/modals/modal-cancellation-policy/modal-cancellation-policy.component';
import { ModalRefuelingFeeComponent } from './billing-summary/modals/modal-refueling-fee/modal-refueling-fee.component';
import { ModalMinimumConditionsComponent } from './billing-summary/modals/modal-minimum-conditions/modal-minimum-conditions.component';
import { ContactInfoComponent } from './billing-summary/components/contact-info/contact-info.component';
import { ConfirmDialogComponent } from './confirm-modal/confirm-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { FunnelDialogComponent } from './funnel-dialog/funnel-dialog.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ExtrasFunnelDialogComponent } from './funnel-dialog/extras-funnel-dialog/extras-funnel-dialog.component';
import { SummaryFunnelDialogComponent } from './funnel-dialog/summary-funnel-dialog/summary-funnel-dialog.component';
import { ModalTyreFullInfoComponent } from './billing-summary/modals/modal-tyre-full-info/modal-tyre-full-info.component';
import { TopbarComponent } from './topbar/topbar.component';
import { SupportModalComponent } from './support-modal/support-modal.component';
import { NotificationsModule } from './notifications/notifications.module';
import { TagManagerComponent } from './tag-manager/tag-manager.component';
import { DateInputComponent } from './date-input/date-input.component';
import { SelectByKeysDropdownComponent } from './select-by-keys-dropdown/select-by-keys-dropdown.component';
import { TablePaginatorComponent } from './table-paginator/table-paginator.component';
import { MoreOptionsTableRowComponent } from './more-options-table-row/more-options-table-row.component';
import { DirectionGoogleMapInputComponent } from './direction-google-map-input/direction-google-map-input.component';
import { WheelCharacteristicsInputComponent } from './wheel-characteristics-input/wheel-characteristics-input.component';
import { MileageCounterComponent } from './mileage-counter/mileage-counter.component';
import { ModalUploadDocumentLinkComponent } from './billing-summary/modals/modal-upload-document-link/modal-upload-document-link.component';
import { TuiFieldErrorPipe, TuiFiles, TuiInputFiles } from '@taiga-ui/kit';
import { TuiError, TuiRoot } from '@taiga-ui/core';
import { ModalCancelVehicleStorageComponent } from '../pages/campas/modal-cancel-vehicle-storage/modal-cancel-vehicle-storage.component';
import { CampaSelectorComponent } from '../pages/campas/components/campa-selector.component';
import { VehicleStorageInfoComponent } from './billing-summary/components/vehicle-storage-info/vehicle-storage-info.component';
import { ModalRenameFileLinkComponent } from './billing-summary/modals/modal-rename-file-link/modal-rename-file-link.component';
import { DocumentInfoComponent } from './billing-summary/components/document-info/document-info.component';
import { DeleteFileModalComponent } from '../pages/new-service/components/new-service-vehicle/dialog/delete-file-modal/delete-file-modal.component';
import { PhoneNumberInputComponent } from './phone-number-input/phone-number-input.component';
import { DistanceTimeBoxComponent } from './billing-summary/components/distance-time-box/distance-time-box.component';
import { HorizontalNavbarComponent } from './horizontal-navbar/horizontal-navbar.component';
import { AddressInputComponent } from './address-input/address-input.component';
import { ServiceContactFormComponent } from './service-contact-form/service-contact-form.component';
import { ReportContentComponent } from './report-content/report-content.component';
import { AddressLineIconComponent } from './address-line-icon/address-line-icon.component';
import { DropdownSelectComponent } from './dropdown-select/dropdown-select.component';
import { VehicleInformationInputComponent } from './vehicle-information-input/vehicle-information-input.component';
import { CurrencyByZoneId } from './pipes/CurrencyByZoneId.pipe';
import { DistanceUnitByZoneId } from './pipes/DistanceUnitByZoneId.pipe';
import { TimezoneDatePipe } from '../pipes/timezone.pipe';
import { RoundDecimalsPipe } from '../pipes/round-decimals.pipe';
import { SkeletonModule } from 'primeng/skeleton';
import { CustomFieldsManagerComponent } from './custom-fields-manager/custom-fields-manager.component';
import { MultiSelectWithInputOptionsComponent } from './multi-select-with-input-options/multi-select-with-input-options.component';
import { FilterStringOptionSelectComponent } from './filter-string-option-select/filter-string-option-select.component';
import { FilterObjectOptionSelectComponent } from './filter-object-option-select/filter-object-option-select.component';
import { ActionDropdownSelectorComponent } from './action-dropdown-selector/action-dropdown-selector.component';
import { ExcelCsvSelectComponent } from './excel-csv-select/excel-csv-select.component';
import { RoleFilterDropdownRowComponent } from './role-filter-dropdown-row/role-filter-dropdown-row.component';
import { MultiSelectInputTagsComponent } from './multi-select-input-tags/multi-select-input-tags.component';
import { GenericDeleteModalComponent } from './generic-delete-modal/generic-delete-modal.component';
import { DateHourServiceFormComponent } from './date-hour-service-form/date-hour-service-form.component';
import { ServiceFiltersRowComponent } from './service-filters-row/service-filters-row.component';

@NgModule({
  declarations: [
    DatatableComponent,
    HeaderComponent,
    MapComponent,
    NavbarComponent,
    PlateNumberComponent,
    StatusComponent,
    ServiceIconsComponent,
    StepperComponent,
    BillingSummaryComponent,
    LogoutComponent,
    ToggleComponent,
    SpinnerDatatableComponent,
    InfoModalComponent,
    FunnelDialogComponent,
    GanttComponent,
    CancelModalComponent,
    ModalCancelVehicleStorageComponent,
    VehicleStatusComponent,
    AlertComponent,
    AddressBoxComponent,
    AdditionalInfoComponent,
    VehicleStorageInfoComponent,
    CommentsComponent,
    PricingSummaryComponent,
    CancellationPolicyComponent,
    CheckoutContainerComponent,
    ModalMinimumConditionsComponent,
    ModalPromotionCodeComponent,
    ModalUploadDocumentLinkComponent,
    ModalRenameFileLinkComponent,
    ModalCancellationPolicyComponent,
    ModalRefuelingFeeComponent,
    ModalMinimumConditionsComponent,
    DeleteFileModalComponent,
    ContactInfoComponent,
    DocumentInfoComponent,
    ConfirmDialogComponent,
    FunnelDialogComponent,
    ExtrasFunnelDialogComponent,
    SummaryFunnelDialogComponent,
    ModalTyreFullInfoComponent,
    TopbarComponent,
    SupportModalComponent,
    TagManagerComponent,
    SelectByKeysDropdownComponent,
    TablePaginatorComponent,
    MoreOptionsTableRowComponent,
    DirectionGoogleMapInputComponent,
    WheelCharacteristicsInputComponent,
    DateInputComponent,
    MileageCounterComponent,
    CampaSelectorComponent,
    DistanceTimeBoxComponent,
    AddressInputComponent,
    PhoneNumberInputComponent,
    DistanceTimeBoxComponent,
    HorizontalNavbarComponent,
    ServiceContactFormComponent,
    ReportContentComponent,
    AddressLineIconComponent,
    DropdownSelectComponent,
    VehicleInformationInputComponent,
    CurrencyByZoneId,
    DistanceUnitByZoneId,
    TimezoneDatePipe,
    RoundDecimalsPipe,
    CustomFieldsManagerComponent,
    MultiSelectWithInputOptionsComponent,
    FilterStringOptionSelectComponent,
    FilterObjectOptionSelectComponent,
    ActionDropdownSelectorComponent,
    ExcelCsvSelectComponent,
    RoleFilterDropdownRowComponent,
    MultiSelectInputTagsComponent,
    GenericDeleteModalComponent,
    DateHourServiceFormComponent,
    ServiceFiltersRowComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    TuiRoot,
    ...TuiFiles,
    TuiInputFiles,
    TuiError,
    TuiFieldErrorPipe,
    HttpClientModule,
    TranslateModule,
    ModalModule.forRoot(),
    MatDialogModule,
    MatTabsModule,
    MatSlideToggleModule,
    NotificationsModule,
    SkeletonModule,
  ],
  exports: [
    DatatableComponent,
    HeaderComponent,
    MapComponent,
    NavbarComponent,
    PlateNumberComponent,
    StatusComponent,
    ServiceIconsComponent,
    StepperComponent,
    BillingSummaryComponent,
    ToggleComponent,
    SpinnerDatatableComponent,
    GanttComponent,
    VehicleStatusComponent,
    AlertComponent,
    ConfirmDialogComponent,
    TopbarComponent,
    NotificationsModule,
    TagManagerComponent,
    DateInputComponent,
    SelectByKeysDropdownComponent,
    TablePaginatorComponent,
    MoreOptionsTableRowComponent,
    DirectionGoogleMapInputComponent,
    WheelCharacteristicsInputComponent,
    MileageCounterComponent,
    AddressBoxComponent,
    CampaSelectorComponent,
    DistanceTimeBoxComponent,
    AddressInputComponent,
    PhoneNumberInputComponent,
    DistanceTimeBoxComponent,
    HorizontalNavbarComponent,
    ServiceContactFormComponent,
    AddressLineIconComponent,
    DropdownSelectComponent,
    VehicleInformationInputComponent,
    CurrencyByZoneId,
    DistanceUnitByZoneId,
    TimezoneDatePipe,
    RoundDecimalsPipe,
    CustomFieldsManagerComponent,
    MultiSelectWithInputOptionsComponent,
    FilterStringOptionSelectComponent,
    FilterObjectOptionSelectComponent,
    ActionDropdownSelectorComponent,
    ExcelCsvSelectComponent,
    RoleFilterDropdownRowComponent,
    MultiSelectInputTagsComponent,
    DateHourServiceFormComponent,
    ServiceFiltersRowComponent,
    ReportContentComponent,
  ],
  providers: [HomeService],
})
export class SharedModule { }
